var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#DDDDDD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.4189 58.5117C67.7678 58.7193 68.1989 58.9626 68.687 59.238C70.8254 60.4443 74.0579 62.268 76.2725 64.4355C77.6573 65.7912 78.9734 67.5777 79.2125 69.7665C79.4669 72.0939 78.4517 74.2782 76.4144 76.2189C72.9002 79.5669 68.6828 82.2501 63.2279 82.2501H36.7731C31.3182 82.2501 27.1008 79.5669 23.5865 76.2189C21.5495 74.2782 20.5341 72.0939 20.7885 69.7665C21.0277 67.5777 22.3437 65.7912 23.7287 64.4355C25.9432 62.268 29.1757 60.4443 31.3142 59.238C31.8021 58.9629 32.2332 58.7193 32.5821 58.5117C43.2443 52.1628 56.7569 52.1628 67.4189 58.5117Z",
    fill: "#1A4F33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M34.25 33.5C34.25 24.8015 41.3015 17.75 50 17.75C58.6985 17.75 65.75 24.8015 65.75 33.5C65.75 42.1985 58.6985 49.25 50 49.25C41.3015 49.25 34.25 42.1985 34.25 33.5Z",
    fill: "#1A4F33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/Avatar.cf46267d75b5271753678861a55bd55f.svg";
export { ForwardRef as ReactComponent };